if (typeof loadeMoreSlider_G === "undefined") {
  globalThis.loadeMoreSlider_G = null;
}

(function () {
  const initSlider = () => {
    const sliders = document.querySelectorAll(".product-card-js");
    const dir = document.querySelector("html").getAttribute("dir");

    let nextEl = ".product-button-group .swiper-button-next";
    let prevEl = ".product-button-group .swiper-button-prev";
    if (dir === "rtl") {
      [nextEl, prevEl] = [prevEl, nextEl];
    }
    sliders.forEach((slider, index) => {
      if (slider?.swiper) return;

      const slideCount = slider.querySelectorAll(".swiper-slide").length;
      const speed = slideCount > 30 ? 0 : 800;

      const productSlider = new Swiper(slider, {
        speed: speed,
        enabled: true,
        pagination: {
          // Scope to THIS card's pagination element. Passing the global string
          // ".product-pagination .swiper-pagination" makes Swiper bind every card's
          // bar via document.querySelectorAll, so the active segment never advances
          // per swipe. (Navigation is already per-card via Swiper's uniqueNavElements.)
          el: slider.querySelector(".product-pagination .swiper-pagination"),
          clickable: true,
        },
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        allowTouchMove: true,
        breakpoints: {
          990: { enabled: true },
        },
      });

      // Desktop only: auto-rotate through the product images while the card is
      // hovered, snapping back to the first image on leave. Guarded by
      // (min-width: 990px) and (hover: hover), so it is completely inert on
      // touch/mobile — the listeners no-op there and never reset the slide.
      const desktopHover = window.matchMedia("(min-width: 990px) and (hover: hover)");
      const rotateDelay = 1700;
      let rotateTimer = null;

      const startRotate = () => {
        if (!desktopHover.matches || rotateTimer || slideCount <= 1) return;
        rotateTimer = setInterval(() => {
          if (productSlider.isEnd) {
            productSlider.slideTo(0, 0); // instant wrap back to the first image
          } else {
            productSlider.slideNext();
          }
        }, rotateDelay);
      };

      const stopRotate = () => {
        if (!rotateTimer) return;
        clearInterval(rotateTimer);
        rotateTimer = null;
        productSlider.slideTo(0, 0); // snap back to the primary image
      };

      slider.addEventListener("mouseenter", startRotate);
      slider.addEventListener("mouseleave", stopRotate);
    });
  };

  initSlider();
  loadeMoreSlider_G = initSlider;

  document.addEventListener("shopify:section:load", function () {
    initSlider();
  });
})();